export interface CreativitySettings {
  temperature: number;
  top_k: number;
  top_p: number;
}

export const CREATIVITY_OPTIONS: Record<
  string,
  { description: string; settings: CreativitySettings }
> = {
  Conservative: {
    description: 'More predictable and safe content',
    settings: { temperature: 0.0, top_k: 5, top_p: 0.6 }
  },
  Balanced: {
    description: 'Balanced approach between creativity and consistency',
    settings: { temperature: 0.95, top_k: 20, top_p: 0.85 }
  },
  Creative: {
    description: 'More creative and varied content',
    settings: { temperature: 1.5, top_k: 30, top_p: 0.95 }
  },
  'Most Creative': {
    description: 'Highly creative and experimental content',
    settings: { temperature: 1.95, top_k: 40, top_p: 0.99 }
  }
};

export const DEFAULT_CREATIVITY = 'Balanced';
